import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-advocates-confirm',
		path: '/p/:slug/advocates/confirm',
		component: loadable(async () => import(/* webpackChunkName: "pages/psf-advocates-confirm" */ './index'), {
			exportName: 'PsfAdvocatesConfirm',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
